import {isNilOrEmpty} from 'ramda-adjunct';

import {
  AdditionalNote,
  useAdditionalNote,
  useVehicleFormContext,
} from '@dms/features/vehicle-forms-kit';

import {suffixTestId} from 'shared/web';

export function AdditionalInfoWidget() {
  const {baseTestId, vehicleId} = useVehicleFormContext();
  const {handleSaveNote} = useAdditionalNote();

  if (isNilOrEmpty(vehicleId)) {
    return null;
  }

  return (
    <AdditionalNote
      vehicleId={vehicleId!}
      onChange={(values) => handleSaveNote(vehicleId!, values?.note ?? '')}
      data-testid={suffixTestId('additional-note', {'data-testid': baseTestId})}
    />
  );
}
